module.exports = __webpack_public_path__ + "static/media/1004001BE.de47d50c.jpg";